import { render, staticRenderFns } from "./CreateApplicantModal.vue?vue&type=template&id=ffa52a3c&"
import script from "./CreateApplicantModal.vue?vue&type=script&lang=js&"
export * from "./CreateApplicantModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports